import { SLIDER_TYPE } from 'Constants/listingSlider';

export const TYPE = 'SLIDER';
export const listingSliderUrl = '/api/bxp/v2/search/bundles';

export const initialState = {};

const getBooleanKey = (state, data, url, sliderType, key) => {
    const existingState = state[sliderType] ? (state[sliderType][key] || '') : {};

    return {
        ...existingState,
        [url]: data
    };
};

const getCollections = (state, data = [], url, sliderType) => {
    const items = data?.[0]?.items;
    const newCollections = {};

    if (Array.isArray(items) && items.length) {
        newCollections[url] = items.map(item => item.id);
    }

    return {
        ...state[sliderType].collections,
        ...newCollections
    };
};

const getElements = (state, data = []) => {
    const items = data?.[0]?.items;

    if (!Array.isArray(items) || items.length === 0) {
        return state.elements;
    }

    const newElements = items.reduce((newElements, item) => {
        return {
            ...newElements,
            [item.id]: {
                ...item
            }
        };
    }, {});

    return {
        ...state.elements,
        ...newElements
    };
};

const getNewSliderState = (oldState, newState, sliderType) => ({
    [sliderType]: {
        ...oldState[sliderType],
        ...newState
    }
});

const listingSlider = (state = initialState, action) => {
    switch (action.type) {
        case `REQUEST_${SLIDER_TYPE.INSPECTION.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                ...getNewSliderState(state, {
                    isFetching: getBooleanKey(state, true, action.url, SLIDER_TYPE.INSPECTION, 'isFetching'),
                    isError: getBooleanKey(state, false, action.url, SLIDER_TYPE.INSPECTION, 'isError')
                }, SLIDER_TYPE.INSPECTION)
            };
        }
        case `RECEIVE_${SLIDER_TYPE.INSPECTION.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                elements: getElements(state, action.data),
                ...getNewSliderState(state, {
                    collections: getCollections(state, action.data, action.url, SLIDER_TYPE.INSPECTION),
                    isFetching: getBooleanKey(state, false, action.url, SLIDER_TYPE.INSPECTION, 'isFetching'),
                    isError: getBooleanKey(state, false, action.url, SLIDER_TYPE.INSPECTION, 'isError')
                }, SLIDER_TYPE.INSPECTION)
            };
        }
        case `ERROR_${SLIDER_TYPE.INSPECTION.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                ...getNewSliderState(state, {
                    isFetching: getBooleanKey(state, false, action.url, SLIDER_TYPE.INSPECTION, 'isFetching'),
                    isError: getBooleanKey(state, true, action.url, SLIDER_TYPE.INSPECTION, 'isError')
                }, SLIDER_TYPE.INSPECTION)
            };
        }
        case `UPDATE_COLLECTION_URL_${SLIDER_TYPE.INSPECTION.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                ...getNewSliderState(state, {
                    lastCollectionUrl: action.url
                }, SLIDER_TYPE.INSPECTION)
            };
        }
        case `REQUEST_${SLIDER_TYPE.OLX_AUTOS.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                ...getNewSliderState(state, {
                    isFetching: getBooleanKey(state, true, action.url, SLIDER_TYPE.OLX_AUTOS, 'isFetching'),
                    isError: getBooleanKey(state, false, action.url, SLIDER_TYPE.OLX_AUTOS, 'isError')
                }, SLIDER_TYPE.OLX_AUTOS)
            };
        }
        case `RECEIVE_${SLIDER_TYPE.OLX_AUTOS.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                elements: getElements(state, action.data),
                ...getNewSliderState(state, {
                    collections: getCollections(state, action.data, action.url, SLIDER_TYPE.OLX_AUTOS),
                    isFetching: getBooleanKey(state, false, action.url, SLIDER_TYPE.OLX_AUTOS, 'isFetching'),
                    isError: getBooleanKey(state, false, action.url, SLIDER_TYPE.OLX_AUTOS, 'isError')
                }, SLIDER_TYPE.OLX_AUTOS)
            };
        }
        case `ERROR_${SLIDER_TYPE.OLX_AUTOS.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                ...getNewSliderState(state, {
                    isFetching: getBooleanKey(state, false, action.url, SLIDER_TYPE.OLX_AUTOS, 'isFetching'),
                    isError: getBooleanKey(state, true, action.url, SLIDER_TYPE.OLX_AUTOS, 'isError')
                }, SLIDER_TYPE.OLX_AUTOS)
            };
        }
        case `UPDATE_COLLECTION_URL_${SLIDER_TYPE.OLX_AUTOS.toUpperCase()}_${TYPE}`: {
            return {
                ...state,
                ...getNewSliderState(state, {
                    lastCollectionUrl: action.url
                }, SLIDER_TYPE.OLX_AUTOS)
            };
        }
        default:
            return state;
    }
};

export default listingSlider;
